import React from 'react';
import {subscribeToWhiteboard} from '../../../firebase/firestore/whiteboards';

export const useWhiteboardMetadata = (whiteboardId) => {
    const [whiteboard, setWhiteboard] = React.useState(null);
    const [metadataError, setMetadataError] = React.useState(null);
    const [metadataLoaded, setMetadataLoaded] = React.useState(false);

    React.useEffect(() => {
        setMetadataLoaded(false);
        const unsubscribe = subscribeToWhiteboard(
            whiteboardId,
            (doc) => {
                setWhiteboard(doc);
                setMetadataError(null);
                setMetadataLoaded(true);
            },
            (err) => {
                setMetadataError(err);
                setMetadataLoaded(true);
            }
        );

        return () => unsubscribe();
    }, [whiteboardId]);

    const refetchTitle = React.useCallback((newTitle) => {
        setWhiteboard((prev) => prev ? {...prev, title: newTitle} : prev);
    }, []);

    const refetchLinks = React.useCallback((links) => {
        setWhiteboard((prev) => (prev ? {...prev, links: Array.isArray(links) ? links : [], associatedProduct: null} : prev));
    }, []);

    return {whiteboard, metadataError, metadataLoaded, refetchTitle, refetchLinks};
};
